import React, { useEffect, useState } from "react";
import blogbg from "../../assests/blog/blog-banner.jpg";
import img1 from "../../assests/blog/Digi.png";
import img14 from "../../assests/blog/AIML.png";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// const categories = ["All", "Business", "Technology", "Design", "Culture", "Updates"];

const BlogPage = () => {
  const navigate = useNavigate();
const [categories, setCategories] =
  useState(["All"]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit] = useState(9);
  const [totalPages, setTotalPages] = useState(1);

  const [search, setSearch] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {

  fetchBlogs(page, search);

  fetchCategories();

}, [page]);
const fetchCategories = async () => {
  try {

    const res = await fetch(
      "https://tekitsolution.com/blog/wp-json/wp/v2/categories"
    );

    const data = await res.json();

    const formattedCategories = [
      "All",
      ...data.map(
        (item) => item.name
      ),
    ];

    setCategories(
      formattedCategories
    );

  } catch (err) {

    console.error(
      "Error fetching categories",
      err
    );

  }
};


  const fetchBlogs = async (pageNo = 1, searchText = "") => {
    try {
      setLoading(true);
const res = await fetch(
  `https://tekitsolution.com/blog/wp-json/wp/v2/posts?_embed&per_page=${limit}&page=${pageNo}&search=${searchText}`
);

const data = await res.json();

const formattedBlogs = data.map((post) => ({
  id: post.id,

  title: post.title.rendered,

  slug: post.slug,

  // ✅ FIX CATEGORY
  category:
  post._embedded?.[
    "wp:term"
  ]?.[0]?.[0]?.name ||

  "Uncategorized",

  short_description:
    post.excerpt.rendered.replace(/<[^>]+>/g, ""),

  image:
    post.yoast_head_json?.og_image?.[0]?.url ||
    img1,
}));

setBlogs(formattedBlogs);

const total = res.headers.get("X-WP-TotalPages");

setTotalPages(Number(total || 1));
setPage(pageNo);
      // const res = await fetch(
      //   `https://api.tekitsolution.com/api/public/blogs?page=${pageNo}&limit=${limit}&search=${searchText}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Accept: "application/json",
      //     },
      //   }
      // );

      // const data = await res.json();

      // setBlogs(data?.data || []);
      // setTotalPages(data?.totalPages || 1);
      // setPage(pageNo);
    } catch (err) {
      console.error("Error fetching blogs", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Blog | Insights, Tips, and Updates on Industry Trends</title>
        <meta
          name="description"
          content="Stay updated with our blog! Get insights, tips, and industry trends on tech, marketing, and more."
      
      />
      <link rel='canonical' href='https://www.tekit.io/blog-page' />
      </Helmet>

      <div className="mx-auto lg:px-24 2xl:px-28 py-10">

        {/* 🔍 Search */}
        <div className="max-w-xl mx-auto mb-6 mt-12">
          <input
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              fetchBlogs(1, e.target.value);
            }}
            placeholder="Search blog posts..."
            className="w-full px-4 py-3 text-[34px] lg:text-[18px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Categories (UI only) */}
       {/* Categories */}

<div className="flex flex-wrap justify-center gap-3 mb-8">

  {categories.map((cat) => (

    <button
      key={cat}
      onClick={() => {

        setSelectedCategory(cat);

        if (cat === "All") {

          fetchBlogs(1, search);

        } else {

          const filtered =
            blogs.filter(
              (blog) =>
                blog.category
                  ?.toLowerCase() ===
                cat.toLowerCase()
            );

          setBlogs(filtered);
        }
      }}

      className={`px-4 py-2 rounded-full text-[34px] lg:text-sm font-medium transition ${
        selectedCategory === cat
          ? "bg-blue-600 text-white"
          : "bg-gray-100 text-gray-700 hover:bg-gray-200"
      }`}
    >
      {cat}
    </button>

  ))}

</div>


        {/* Loader */}
        {loading && (
          <div className="text-center text-lg py-10">Loading blogs...</div>
        )}

        {/* Blog Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {blogs.map((post, idx) => (
            <div
              key={idx}
              className="bg-white border rounded-xl p-5 shadow-sm flex flex-col justify-between h-full"
            >
              <div>
                <img
                  src={post?.image || img1}
                  className="w-full lg:h-44 2xl:h-60 object-cover rounded-md"
                  alt="blog"
                />

                <h2 className="2xl:text-[20px] lg:text-[16px] text-[44px] mt-4 font-bold text-center text-gray-900">
                  {post?.title}
                </h2>

                <p className="text-gray-600 text-center 2xl:text-[16px] text-[36px] lg:text-[13px] mt-2">
                  {post?.short_description}
                </p>
              </div>

              <div className="mt-4 text-center">
                <button
                  className="lg:w-[40%] 2xl:w-[30%] w-full text-white rounded-lg lg:px-4 px-10 lg:py-2 py-4 text-[34px] lg:text-sm hover:bg-blue-700 bg-blue-600 font-medium"
   onClick={() => {
 navigate(
  `/insights/blog/${post?.category}/${post?.slug}`
);

window.scrollTo({
  top: 0,
  behavior: "smooth",
});
  }}
                >
                  Read More
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10 gap-2 flex-wrap">
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => setPage(i + 1)}
              className={`px-4 py-2 rounded ${
                page === i + 1
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200"
              }`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogPage;